module.exports = "pegasus_template/assets/graycircle-facebook.gif";